import { React } from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

function NotFoundPage() {
    return (
        <div className="not-found-page">
            <div className="not-found-container">
                <h2>Oops! Page not found.</h2>
                <h1>404</h1>
                <h2>We couldn't find the page you were looking for.</h2>
                <Link to="/home">Go Back Home</Link>
            </div>
        </div>
    );
}

export default NotFoundPage;